(function () {
  var STORAGE_KEY = 'leonidas:vat-display';
  // Fallback factor (per mille) for price nodes without data-vat-rate
  var DEFAULT_RATE = 1060;

  function getMode() {
    if (window.leonidasB2bNet) return 'excl';
    try {
      return localStorage.getItem(STORAGE_KEY) === 'excl' ? 'excl' : 'incl';
    } catch (e) {
      return 'incl';
    }
  }

  function setMode(mode) {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {}
  }

  function formatPrice(cents, withCurrency) {
    var formats = window.leonidasVatFormats || {};
    var format = withCurrency ? formats.withCurrency : formats.plain;
    return formatMoney(cents, format);
  }

  function applyMode(mode) {
    var nodes = document.querySelectorAll('[data-price-cents]');
    nodes.forEach(function (node) {
      var cents = parseInt(node.getAttribute('data-price-cents'), 10);
      if (isNaN(cents)) return;
      var withCurrency = node.getAttribute('data-price-with-currency') === 'true';
      var rate = parseFloat(node.getAttribute('data-vat-rate')) || DEFAULT_RATE;
      var displayCents = mode === 'excl' ? Math.round((cents * 1000) / rate) : cents;
      // Keep the surrounding whitespace so the price does not shift when toggling
      var parts = node.textContent.match(/^(\s*)[\s\S]*?(\s*)$/);
      var text = parts[1] + formatPrice(displayCents, withCurrency) + parts[2];
      if (node.textContent !== text) node.textContent = text;
      node.__vatText = text;
    });

    document.documentElement.setAttribute('data-vat-display', mode);
    document.documentElement.setAttribute('data-vat-ready', '');

    document.querySelectorAll('[data-vat-toggle]').forEach(function (toggle) {
      toggle.checked = mode === 'incl';
    });

    document.querySelectorAll('[data-vat-toggle-text]').forEach(function (label) {
      label.textContent = mode === 'excl' ? label.dataset.labelExcl : label.dataset.labelIncl;
    });
  }

  // Apps write the variant price straight from Shopify's variant data, which is the net price
  // in tax-exclusive markets. Store it incl. local VAT so the switch shows the right amount.
  function adoptExternalPrice(node) {
    var digits = node.textContent.replace(/[^\d]/g, '');
    if (!digits) return false;
    // Stop if an app keeps rewriting the same price, so we never end up in a loop with it
    var now = Date.now();
    if (!node.__vatAdoptStart || now - node.__vatAdoptStart > 1000) {
      node.__vatAdoptStart = now;
      node.__vatAdoptCount = 0;
    }
    if (++node.__vatAdoptCount > 5) return false;
    var cents = parseInt(digits, 10);
    if (window.leonidasNetPrices) {
      var rate = parseFloat(node.getAttribute('data-vat-rate')) || DEFAULT_RATE;
      cents = Math.round((cents * rate) / 1000);
    }
    node.setAttribute('data-price-cents', cents);
    return true;
  }

  function init() {
    applyMode(getMode());

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-vat-toggle]')) return;
      var mode = event.target.checked ? 'incl' : 'excl';
      setMode(mode);
      applyMode(mode);
    });

    var observer = new MutationObserver(function (mutations) {
      var needsApply = false;
      mutations.forEach(function (mutation) {
        // An app (Optis product options) rewrote a price we render: adopt its amount
        var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        var priceNode = target && target.closest('[data-price-cents]');
        if (priceNode && priceNode.textContent !== priceNode.__vatText && adoptExternalPrice(priceNode)) {
          needsApply = true;
        }
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.hasAttribute('data-price-cents') || node.querySelector('[data-price-cents]')) {
            needsApply = true;
          }
        });
      });
      if (needsApply) applyMode(getMode());
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
